import { axiosApi, createCRUD } from '@/api/axios';

export default {
  ...createCRUD('visual_number_requests'),
  create(kiwFormData) {
    return axiosApi.post('/visual_number_requests', kiwFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      transformRequest: [
        (data) => data,
      ],
    });
  },
  bulkDelete(requestIds) {
    return axiosApi.delete('/visual_number_requests/bulk_delete', { params: { requestIds } });
  },
  actions: {
    show(id) {
      return axiosApi.get(`/visual_number_requests/${id}/actions`);
    },
    set(id, actionData) {
      return axiosApi.patch(`/visual_number_requests/${id}/actions`, actionData);
    },
  },

  files: {
    upload(id, formData) {
      return axiosApi.post(`/visual_number_requests/${id}/files`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        transformRequest: [
          (data) => data,
        ],
      });
    },
    delete(id, fileIds) {
      return axiosApi.delete(`/visual_number_requests/${id}/files`, {
        data: {
          ids: fileIds,
        },
      });
    },
    downloadFiles(fileIds) {
      return axiosApi.get('/request_files/zip', {
        params: { fileIds },
        responseType: 'blob',
      });
    },
  },
};
